// extracted by mini-css-extract-plugin
export var container = "_lj-0";
export var dotAnimation = "_lj-2";
export var dotsLoading = "_lj-1";